import { ChangeEvent } from "react";

import { Specimen } from "pwapi";

import { procedureEnumToLabel } from "shared/utils/specimenUtils";

import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";

type SpecimenFiltersProps = {
  specimensBiopsyType: string;
  specimensProcedure: string;
  specimensType: string;
  specimensSource: string;
  specimensSite: string;

  onChange: Function;
};

const SpecimenFilters = (props: SpecimenFiltersProps) => {
  return (
    <>
      <TextInput
        id="specimensSource"
        value={props.specimensSource}
        label="WPL Specimen Source"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          props.onChange("specimensSource", e.target.value || "")
        }
        onClear={() => props.onChange("specimensSource", "")}
      />
      <SelectInput
        id="specimensBiopsyType"
        label="WPL Specimen Biopsy Type"
        defaultLabel="All Types"
        options={Object.values(Specimen.biopsy_type).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.specimensBiopsyType}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensBiopsyType", e.target.value || "")
        }
      />
      <SelectInput
        id="specimensType"
        label="Specimen Type"
        defaultLabel="All Types"
        options={Object.values(Specimen.type).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.specimensType}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensType", e.target.value || "")
        }
      />
      <TextInput
        id="specimensSite"
        value={props.specimensSite}
        label="Specimen Site"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          props.onChange("specimensSite", e.target.value || "")
        }
        onClear={() => props.onChange("specimensSite", "")}
      />
      <SelectInput
        id="specimenProcedure"
        label="Specimen Procedure"
        defaultLabel="All Procedures"
        options={Object.values(Specimen.procedure).map((v) => ({
          label: procedureEnumToLabel(v) || "",
          value: v,
        }))}
        value={props.specimensProcedure}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          props.onChange("specimensProcedure", e.target.value || "")
        }
      />
    </>
  );
};

export default SpecimenFilters;
